import { axiosClient } from "@/lib/axiosClient";

export interface PublicDocument {
    id: number;
    title: string;
    description: string | null;
    category: string | null;
    file_type: string | null;
    file_url: string;
    display_order: number;
    created_at: string;
}

export const getPublicDocuments = async (): Promise<PublicDocument[]> => {
    const { data } = await axiosClient.get("/public/documents");
    return data;
};
